import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

const ScribeBulkRegenerateModal = ({ isOpen, onClose, onConfirm, consultations, loading, getPatientName }) => {
  if (!isOpen || !consultations || consultations.length === 0) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Regenerate Consultations</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to regenerate {consultations.length} consultation{consultations.length > 1 ? 's' : ''}?</p>
          <div className="bulk-document-list">
            {consultations.slice(0, 5).map(consultation => (
              <div key={consultation.consultationId} className="bulk-document-item">
                <div className="bulk-document-name">{getPatientName(consultation.nhsId)}</div>
                <div className="bulk-document-assignee">{consultation.timestamp ? new Date(consultation.timestamp).toLocaleDateString() : 'Unknown'}</div>
              </div>
            ))}
            {consultations.length > 5 && (
              <div className="bulk-document-more">
                ... and {consultations.length - 5} more consultation{consultations.length - 5 > 1 ? 's' : ''}
              </div>
            )}
          </div>
          <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
            This will create new AI-generated content for all selected consultations, replacing their current content.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="regenerate-confirm-button" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              'Regenerate All'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScribeBulkRegenerateModal;
